export const dataStatus = {
    yearEinwohner: 2026,
    yearTagbev: 2024,
    yearGIP: 2024
}